<template>
  <div class="ui-enter">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ui-enter',
  }
</script>

<style lang="scss">
  .ui-enter {
    position: relative;

    .membership-link {
      width: 12rem;
      height: 12rem;
      padding: var(--padding-x50);
      border: 1px solid;
      display: flex;
      position: absolute;
      right: -5rem;
      text-align: center;
      align-items: center;
      justify-content: center;
      top: 0;
      border-radius: 50%;
      display: none;
    }


    p,
    div,
    h1,h2,h3,h4,
    ul, ol {
      margin: 0 0 var(--padding) 0;
    }

    h1:not(:first-child) {
      margin-top: var(--padding-x2);
    }

    h2:not(:first-child),
    h3:not(:first-child),
    h4:not(:first-child) {
      margin-top: var(--padding);
    }

    h1 {
      font-size: var(--title-size);
      letter-spacing: var(--letter-spacing);
      line-height: 1.05;
    }

    h2,
    h3 {
      font-size: var(--medium-size);
      letter-spacing: var(--letter-spacing);
      line-height: 1.2;
      margin: var(--padding) 0 var(--padding-50);
    }

    h4 {
      margin-bottom: 0;
    }

    h5,
    h6 {
      font-size: var(--small-size);
    }

    ol, ul {
      margin-left: 2rem;

      li {
        margin: 0;
      }
    }

    ul {
      list-style-type: disc;
      list-style-position: outside;
      list-style-image: none;
    }

    ol {
      list-style-type: decimal;
      list-style-position: outside;
      list-style-image: none;
    }

    blockquote {
      right: -18rem;
      position: relative;
      margin: var(--padding) 0;
      line-height: 1.2;
      width: 83%;
    }

    .gallery {
      display: none;
    }

    .wp-caption,
    .embed-image {
      display: block;
      margin: var(--padding) 0;
      width: auto !important;

      img {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 80vh;
        margin: auto;
      }

      .wp-caption-text {
        margin-top: .75rem;
        font-size: var(--small-size);
      }
    }

    .box > p .wp-caption,
    .box > p .embed-image {
      width: calc(100% + 24rem) !important;
      margin-left: -12rem;
    }

    iframe {
      max-width: 100%;
    }

    .embed-video {
      display: block;
      margin: var(--padding) 0;
      width: auto !important;
      position: relative;

      &::before {
        display: block;
        content: '';
        padding-top: 56.2%;
      }

      iframe {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }

    .gca-column {
      float: left;
      margin: 0 0 var(--padding) 0;

      &.one-half {
        width: 50%;
        box-sizing: border-box;
        padding-right: var(--padding-50);

        & + .one-half {
          padding-right: 0;
          padding-left: var(--padding-50);
        }
      }

      & + h2,
      & + h3,
      & + h4,
      & + ol,
      & + ul,
      & + p,
      & + br {
        clear: both;
      }
    }

    .link-button {
      display: block;
      line-height: 1;
      border: 1px solid;
      text-align: center;
      cursor: pointer;
      padding: 1rem 2rem;
      width: fit-content;
      margin: auto;
      min-width: 23rem;

      &:hover {
        color: white;
        background-color: black;
      }
    }
  }

  .inner .ui-enter {
    & > .box {
      margin: 0 12rem var(--padding) 12rem;

      // img:first-child {
      //     margin: 0 -10rem;
      //     width: calc(100% + 20rem);
      // }

      // .wp-caption:first-child .wp-caption-text {
      //     margin: 0 0 var(--padding-x2) 0;
      // }
    }

    a {
      border-bottom: 1px solid;
    }

    //.embed-image, .wp-caption { margin: var(--padding-x2) -10rem;}
  }

  @media only screen and (max-width: 767px) {
    .inner .ui-enter {
      & > .box {
        margin: 0 0 var(--padding-x2) 0;
      }
    }

    .ui-enter {
      ol, ul {
        margin-left: var(--padding);
      }

      blockquote {
        right: -5rem;
        margin: var(--padding-x2) 0;
      }

      .gca-column {
        margin: 0 0 var(--padding) 0;
      }

      .gca-column.one-half {
        width: 100%;
      }

      .gca-column.one-half+.one-half {
        padding-left: 0;
      }

      .box > p .wp-caption,
      .box > p .embed-image {
        width: auto !important;
        margin-left: 0;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      //.link-button {}
    }
  }
</style>
